export function RichTextResponsiveTable(selector) {
    let tables = document.querySelectorAll(selector);
    if (tables.length === 0) return;

    let rafThrottle = (callback) => {
        let rafId = null;
        return () => {
            if (rafId) return;
            rafId = window.requestAnimationFrame(() => {
                rafId = null;
                callback();
            });
        };
    };

    let init = (table) => {
        if (document.body.classList.contains('neos-backend')) {
            return;
        }

        let tableInner = table.querySelector('table');
        if (!tableInner) {
            return;
        }

        let scrollButtons = document.createElement('DIV');
        if (tableInner.scrollWidth <= tableInner.clientWidth) return;

        let intLabels = JSON.parse(table.closest('.rich-text').dataset.labels);
        scrollButtons.classList.add('container__scroll-buttons');
        scrollButtons.innerHTML = `
            <button class="container__scroll-button container__scroll-button--left" id="scroll-left" aria-label="${intLabels.left}" title="${intLabels.left}"></button>
            <button class="container__scroll-button container__scroll-button--right container__scroll-button--is-available" id="scroll-right" aria-label="${intLabels.right}" title="${intLabels.right}"></button>`;
        let scrollButtonsArray = Array.from(scrollButtons.querySelectorAll('button'));

        table.prepend(scrollButtons);
        let buttonLeft = scrollButtons.querySelector('.container__scroll-button--left');
        let buttonRight = scrollButtons.querySelector('.container__scroll-button--right');

        scrollButtonsArray.forEach((element) => {
            element.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                let type = 'left';
                if (e.target.classList.contains('container__scroll-button--right')) {
                    type = 'right';
                }

                tableInner.scrollTo({
                    top: 0,
                    left: tableInner.scrollLeft + window.innerWidth * (type === 'left' ? -1 : 1),
                    behavior: 'smooth',
                });
            });
        });

        let updateButtons = () => {
            let isEdgeLeft = tableInner.scrollLeft <= 10;
            let isEdgeRight = tableInner.scrollWidth - tableInner.scrollLeft - tableInner.clientWidth <= 10;

            buttonLeft.classList[isEdgeLeft ? 'remove' : 'add']('container__scroll-button--is-available');
            buttonRight.classList[isEdgeRight ? 'remove' : 'add']('container__scroll-button--is-available');
        };

        let scheduleButtonsUpdate = rafThrottle(updateButtons);
        tableInner.addEventListener('scroll', scheduleButtonsUpdate, { passive: true });
        window.addEventListener('resize', scheduleButtonsUpdate, { passive: true });
        scheduleButtonsUpdate();
    };

    Array.from(tables).forEach((element) => {
        window.requestAnimationFrame(() => init(element));
    });
}
